import { render, staticRenderFns } from "./delivered-orders.vue?vue&type=template&id=b16a7932&"
import script from "./delivered-orders.vue?vue&type=script&lang=js&"
export * from "./delivered-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports